namespace TabAurous.OMS {
    export interface RolePermissionListResponse extends Serenity.ListResponse<string> {
    }
}
